// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.
export const environment = {
  production: false,
  firebase : {
    apiKey: "AIzaSyBltPQtZefIEFRvnMXrXPYgU_mIgz5YAPk",
    authDomain: "gestione-sottoscrizione.firebaseapp.com",
    projectId: "gestione-sottoscrizione",
    storageBucket: "gestione-sottoscrizione.firebasestorage.app",
    messagingSenderId: "338327358928",
    appId: "1:338327358928:web:0ad8ec8529893ca0f6bdd5"
  },
  apiurl: "http://localhost:3002/api/api",
  //apiurldap: "https://wsprodap.ance.it/api/Autenticazione",
  nameCookie: "__session",
  domainCookie: "localhost",/* vecchia logica*/
  //urlSurvey: "http://localhost:4200/ance/check?idToken="
};
/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
